// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__304Kc","questions":"styles_questions__fGZKO","footer":"styles_footer__N-Q-l"};